import flex from "../../../../styles/flex";
import palette from "../../../../styles/palette";

export default {
    wrapper: {
        backgroundColor: palette.bg.nav,
        borderBottom: `solid 1px ${palette.border.primary}`
    } as React.CSSProperties,
    container: {
        ...flex.flexRows,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center"
    } as React.CSSProperties,
    search: {
        paddingTop: 10,
        paddingLeft: 10
    } as React.CSSProperties,
    searchSm: {
        paddingTop: 10,
        paddingRight: 10
    } as React.CSSProperties,
    loggedInAs: {
        padding: 10, minWidth: 180
    } as React.CSSProperties,
    workingAtSite: {
        padding: 10, minWidth: 250
    } as React.CSSProperties,
    notificationIcon: {
        padding: 10, paddingRight: 20
    } as React.CSSProperties,
    userDetails: {
        ...flex.flexFill, textAlign: "left",
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: 12
    } as React.CSSProperties,
    environment: {
        color: palette.text.primary,
        textAlign: "center",
        textTransform: "capitalize",
    } as React.CSSProperties,

}
